import { render, staticRenderFns } from "./NovidadesResourceIndex.vue?vue&type=template&id=43efbbd8&"
import script from "./NovidadesResourceIndex.vue?vue&type=script&lang=js&"
export * from "./NovidadesResourceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports